import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
export function tags(keyword, mode) {
  if (mode === "channel") {
    return {
      title: `${keyword}の動画配信 - 月額動画配信 | SPOOX(スプークス)`,
      keywords: "SPOOX,スプークス,動画配信,見放題,レンタル,スカパー！",
      description: `月額商品にある${keyword}の検索結果。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中！`,
      og: {
        type: "article",
        url: `${config.host.vod}${routes.search(keyword, "channel")}`
      }
    };
  } else if (mode === "store") {
    return {
      title: `${keyword}の動画配信 - 単品商品 | SPOOX(スプークス)`,
      keywords: "SPOOX,スプークス,動画配信,レンタル,スカパー！",
      description: `単品商品にある${keyword}の検索結果。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中！`,
      og: {
        type: "article",
        url: `${config.host.vod}${routes.search(keyword, "store")}`
      }
    };
  } else if (mode === "valueplan") {
    return {
      title: `${keyword}の動画配信 - ${config.valuePlan.text} | SPOOX(スプークス)`,
      keywords: "SPOOX,スプークス,動画配信,レンタル,スカパー！",
      description: `${config.valuePlan.text}にある${keyword}の検索結果。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中！`,
      og: {
        type: "article",
        url: `${config.host.vod}${routes.search(keyword, "valueplan")}`
      }
    };
  } else {
    return {
      title: `${keyword}の動画配信 | SPOOX(スプークス)`,
      keywords: "SPOOX,スプークス,動画配信,レンタル,スカパー！",
      description: `${keyword}の検索結果。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中！`,
      og: {
        type: "article",
        url: `${config.host.vod}${routes.search(keyword)}`
      }
    };
  }
}
export default function SearchPageMetaTags(_ref) {
  let {
    keyword,
    mode
  } = _ref;
  const props = tags(keyword, mode);
  return /*#__PURE__*/_jsx(MetaTags, _objectSpread({}, props));
}